import { Component, inject } from '@angular/core';
import { DeliveryOptions, deliveryValues } from '@shared';
import { CurrencyPipe } from '@angular/common';
import { ProgressService } from '../../lib/progress.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-booking-shipping',
  imports: [CurrencyPipe, RouterLink],
  templateUrl: './booking-shipping.component.html',
  styleUrl: './booking-shipping.component.css',
})
export class BookingShippingComponent {
  public deliveryOptions: DeliveryOptions[] = deliveryValues;
  public progressService = inject(ProgressService);

  selectShipping(deliveryOption: DeliveryOptions) {
    this.progressService.shippingSelected(deliveryOption);
  }
}
